export default __webpack_public_path__ + "static/media/deleteIcon.0f1112f7.svg";